import styled from 'styled-components';

import { StyledControlBarButton } from '../control-bar-button.styles';

export const StyledSpeechButton = styled(StyledControlBarButton)`
  filter: ${props => (props.isOpen || props.isPlaying) ? 'none' : 'grayscale(100%)'} brightness(1);

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    filter: none;
  }

  &:before {
    border: 11px solid transparent;
    border-bottom-color: ${props =>
      props.theme.themeColors.settingsDropdown.borderColor};
    right: 29px;
  }
  position: relative;
  
  animation: ${props => props.isPlaying ? 'flickerAnimation 1.5s infinite' : 'none'};  
  @keyframes flickerAnimation {
    0%   { filter: brightness(1); }
    50%  { filter: brightness(1.3); }
    100% { filter: brightness(1); }
  }
`;
